import { render, staticRenderFns } from "./OContent.vue?vue&type=template&id=7861c64c&"
import script from "./OContent.vue?vue&type=script&lang=ts&"
export * from "./OContent.vue?vue&type=script&lang=ts&"
import style0 from "./OContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports